// routes.js

import Dashboard from "./crm/views/common/dashboard/dashboard";
import Main from "./crm/views/layouts/main/main";
import SwitchRole from "./crm/views/layouts/SwitchRole";
import UnderMaintenance from "./crm/views/layouts/UnderMaintenance";
import AuditFormEdit from "./crm/views/qms/auditForms/auditFormEdit";
import AuditForms from "./crm/views/qms/auditForms/auditForms";
import AuditFormView from "./crm/views/qms/auditForms/auditFormView";
import Audits from "./crm/views/qms/audits/audits";
import AuditView from "./crm/views/qms/auditView/auditView";
import ClientEscalation from "./crm/views/qms/clientEscalation/clientEscalation";
import NewClientEscalation from "./crm/views/qms/clientEscalation/newClientEscalation";
import ClientEscalationView from "./crm/views/qms/clientEscaltionView/clientEscalationView";
import Clients from "./crm/views/qms/clients/clients";
import DeletedAuditView from "./crm/views/qms/deletedAudits/deletedAuditView";
import Departments from "./crm/views/qms/departments/departments";
import Processes from "./crm/views/qms/processes/processes";
import Roles from "./crm/views/common/roles/roles";
import Users from "./crm/views/common/users/users";
import Sections from "./crm/views/common/sections/sections";
import ImportBulkData from "./crm/views/common/settings/importBulkData";
import RoleAccessControl from "./crm/views/common/settings/role-access-control";
import ThemeOptions from "./crm/views/common/settings/theme-options";
import FeedbackRequestPreview from "./crm/views/voc/feedbackRequests/feedbackRequestPreview";
import FeedbackRequests from "./crm/views/voc/feedbackRequests/feedbackRequests";
import SendForms from "./crm/views/voc/forms/forms";
import InternalErrorRca from "./crm/views/qms/internalErrorRca/internalErrorRca";
import InternalErrorRcaView from "./crm/views/qms/internalErrorRcaView/internalErrorRcaView";
import AddAuditForm from "./crm/views/qms/auditForms/addAuditForms";
import AddRole from "./crm/views/common/roles/addRole";
import AddUser from "./crm/views/common/users/addUser";

import DeletedAudits from "./crm/views/qms/deletedAudits/deletedAudits";
import Permissions from "./crm/views/common/permissions/permissions";
import InternalErrorRcaForm from "./crm/views/qms/internalErrorRca/internalErrorRcaForm";
import AddEditForm from "./crm/components/molecules/Forms/addEditForm";
import Logs from "./crm/views/common/logs/logs";
import AddForm from "./crm/views/voc/forms/addForm";

export const componentMap = {
  "/dashboard": (
    <Main children={<Dashboard />} key_elem={"1"} nameLink="Dashboard" />
  ),
  "/auditForms": (
    <Main children={<AuditForms />} key_elem={"2"} nameLink="Audit Forms" />
  ),
  "/auditForms/:id": (
    <Main
      children={<AuditFormView />}
      key_elem={"3"}
      nameLink="AuditForm View"
    />
  ),
  "/auditForms/edit/:id": (
    <Main
      children={<AuditFormEdit />}
      key_elem={"4"}
      nameLink="AuditForm Edit"
    />
  ),
  "/auditForms/add": (
    <Main children={<AddAuditForm />} key_elem={"5"} nameLink="Add AuditForm" />
  ),
  "/audits": <Main children={<Audits />} key_elem={"6"} nameLink="Audits" />,

  "/deleted-audits": (
    <Main
      children={<DeletedAudits />}
      key_elem={"7"}
      nameLink="Deleted Audits"
    />
  ),
  "/deleted-audits/:id": (
    <Main
      children={<DeletedAuditView />}
      key_elem={"8"}
      nameLink="Deleted Audit View"
    />
  ),
  "/audits/:id": (
    <Main children={<AuditView />} key_elem={"9"} nameLink="Audit View" />
  ),
  "/users": <Main children={<Users />} key_elem={"10"} nameLink="Users" />,
  "/users/add": (
    <Main children={<AddUser />} key_elem={"11"} nameLink="Add User" />
  ),
  "/roles": <Main children={<Roles />} key_elem={"12"} nameLink="Roles" />,
  "/roles/add": (
    <Main children={<AddRole />} key_elem={"13"} nameLink="Add Role" />
  ),
  "/auditReports": () => <div>Audit Reports</div>, // Replace with your Audit Reports component <Main children={<></> } key_elem={'3'} nameLink='Audit Reports' />

  "/escalations/client-escalation": (
    <Main
      children={<ClientEscalation children={<NewClientEscalation />} />}
      key_elem={"14"}
      nameLink="Client Escalation"
    />
  ),
  "/escalations/client-escalation/:id": (
    <Main
      children={<ClientEscalationView />}
      key_elem={"15"}
      nameLink="Client Escalation View"
    />
  ),
  "/escalations/internal-error-rca": (
    <Main
      children={<InternalErrorRca children={<InternalErrorRcaForm />} />}
      key_elem={"16"}
      nameLink="Internal Error RCA"
    />
  ),
  "/escalations/internal-error-rca/:id": (
    <Main
      children={<InternalErrorRcaView />}
      key_elem={"17"}
      nameLink="Internal Error RCA View"
    />
  ),
  "/clients": (
    <Main children={<Clients />} key_elem={"18"} nameLink="Clients" />
  ),
  "/processes": (
    <Main children={<Processes />} key_elem={"19"} nameLink="Processes" />
  ),
  "/departments": (
    <Main children={<Departments />} key_elem={"20"} nameLink="Departments" />
  ),
  "/forms": (
    <Main children={<SendForms />} key_elem={"21"} nameLink="Send Forms" />
  ),
  "/forms/add": (
    <Main children={<AddForm />} key_elem={"22"} nameLink="Add Form" />
  ),

  "/feedback-requests/:type": (
    <Main
      children={<FeedbackRequests />}
      key_elem={"23"}
      nameLink="Feedback Requests"
    />
  ),
  "/feedback-requests/preview/:id": (
    <Main
      children={<FeedbackRequestPreview />}
      key_elem={"24"}
      nameLink="Feeback Request Preview"
    />
  ),
  "/settings/theme-options": (
    <Main
      children={<ThemeOptions />}
      key_elem={"25"}
      nameLink="Theme Options"
    />
  ),
  "/settings/import-bulk-data": (
    <Main
      children={<ImportBulkData />}
      key_elem={"26"}
      nameLink="Import Bulk Data"
    />
  ),
  "/settings/role-access-control": (
    <Main
      children={<RoleAccessControl />}
      key_elem={"27"}
      nameLink="Role Access Control"
    />
  ),
  "/permissions": (
    <Main children={<Permissions />} key_elem={"28"} nameLink="Permissions" />
  ),
  "/sections": (
    <Main children={<Sections />} key_elem={"29"} nameLink="Sections" />
  ),
  "/switch-role": (
    <Main children={<SwitchRole />} key_elem={"30"} nameLink="Switch Role" />
  ),
  "/logs": <Logs />,
  noRoute: "/404",
  "/underMaintenance": <UnderMaintenance />,
};

export const roles = {
  admin: [
    "/dashboard",
    "/auditForms/:id",
    "/auditForms/edit/:id",
    "/auditForms",
    "/audits",
    "/audits/:id",
    "/deleted-audits",
    "/deleted-audits/:id",
    "/escalations",
    "/escalations/:id",
    "/escalations/client-escalation",
    "/escalations/client-escalation/:id",
    "/escalations/internal-error-rca",
    "/escalations/internal-error-rca/:id",
    "/clients",
    "/departments",
    "/processes",
    "/sections",
    "/permissions",
    "/roles",
    "/users",
    "/forms",
    "/forms/add",
    "/feedback-requests",
    "/feedback-requests/:type",
    "/feedback-requests/preview/:id",
    "/settings/theme-options",
    "/settings/import-bulk-data",
    "/settings/role-access-control",
    "/survey/:id",
    "/switch-role",
    "/logs",
  ],
  qc: [
    "/dashboard",
    "/auditForms",
    "/auditForms/:id",
    "/auditForms/edit/:id",
    "/audits",
    "/audits/:id",
    "/departments",
    "/deleted-audits",
    "/deleted-audits/:id",
    "/escalations",
    "/escalations/:id",
    "/escalations/client-escalation",
    "/escalations/client-escalation/:id",
    "/escalations/internal-error-rca",
    "/escalations/internal-error-rca/:id",
    "/users",
    "/forms",
    "/feedback-requests",
    "/feedback-requests/:type",
    "/processes",
    "/survey/:id",
    "/feedback-requests/preview/:id",
    "/switch-role",
  ],

  auditor: [
    "/dashboard",
    "/auditForms",
    "/auditForms/:id",
    "/audits",
    "/audits/:id",
    "/deleted-audits",
    "/deleted-audits/:id",
    "/escalations/internal-error-rca",
    "/escalations/internal-error-rca/:id",
    "/switch-role",
  ],
  agent: ["/dashboard", "/audits", "/audits/:id", "/switch-role"],
  tl: [
    "/dashboard",
    "/audits",
    "/audits/:id",
    "/escalations/client-escalation",
    "/escalations/client-escalation/:id",
    "/escalations/internal-error-rca",
    "/escalations/internal-error-rca/:id",
    "/switch-role",
  ],
  atl: [
    "/dashboard",
    "/audits",
    "/audits/:id",
    "/escalations/client-escalation",
    "/escalations/client-escalation/:id",
    "/escalations/internal-error-rca",
    "/escalations/internal-error-rca/:id",
    "/switch-role",
  ],
  am: [
    "/dashboard",
    "/audits",
    "/audits/:id",
    "/escalations/client-escalation",
    "/escalations/client-escalation/:id",
    "/escalations/internal-error-rca",
    "/escalations/internal-error-rca/:id",
    "/switch-role",
  ],
  manager: ["/dashboard", "/audits", "/audits/:id", "/switch-role"],
  avp: ["/dashboard", "/audits", "/audits/:id", "/switch-role"],
  vp: ["/dashboard", "/audits", "/audits/:id", "/switch-role"],
};
